import React from 'react';
import type { AutoproxyResponse } from 'venn-api';
import PossibleProxiesTable from './PossibleProxiesTable';
import { ReturnsCalculations } from 'venn-utils';
import type { SelectedProxy } from '../utils';

interface AutoproxyOptionsProps {
  autoproxyResponse?: AutoproxyResponse;
  setSelectedProxy: (proxy: SelectedProxy) => void;
}

const AutoproxyOptions: React.FC<React.PropsWithChildren<AutoproxyOptionsProps>> = ({
  autoproxyResponse,
  setSelectedProxy,
}) => {
  const autoproxyOptions = autoproxyResponse?.results
    ? autoproxyResponse.results.map((result) => ({
        proxy: result.proxy,
        proxiedReturns: ReturnsCalculations.toDataPoints(result.cumulativeProxiedReturns ?? []),
        proxiedStart: result.proxiedStart,
        proxiedEnd: result.proxiedEnd,
        extrapolatedStart: result.extrapolatedStart,
        correlation: result.correlation,
        percentMatch: result.percentMatch,
      }))
    : [];

  return autoproxyOptions?.length ? (
    <PossibleProxiesTable results={autoproxyOptions.slice(0, 5)} onSelect={setSelectedProxy} />
  ) : null;
};

export default AutoproxyOptions;
